export const sdBaseUrl = '/data/hana/';
export const mdBaseUrl = '/data/hana/';
export const fiBaseUrl = '/data/hana/';
export const imBaseUrl = '/data/hana/';
export const baseUrl = '/data/hana/';
export const mmBaseUrl = '/data/hana/';
export const contractBaseUrl = '/data/hana/';
export const registerBaseUrl = '/register/data/hana/';
export const openBaseUrl = '/open/data/hana/';